// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfusionMatrixContainer-module__dsAccented--vq4_j,.ConfusionMatrixContainer-module__dsAccented--vq4_j *{font-weight:500}.ConfusionMatrixContainer-module__dsDefaultWeight--snGUb,.ConfusionMatrixContainer-module__dsDefaultWeight--snGUb *{font-weight:400}h5.ConfusionMatrixContainer-module__dsAccented--vq4_j,h5.ConfusionMatrixContainer-module__dsAccented--vq4_j *{font-weight:700}.ConfusionMatrixContainer-module__dsUnderline--ISw2P,.ConfusionMatrixContainer-module__dsUnderline--ISw2P *{text-decoration:underline}.ConfusionMatrixContainer-module__dsAccented2--SAnCD,.ConfusionMatrixContainer-module__dsAccented2--SAnCD *{font-weight:700}.ConfusionMatrixContainer-module__dsBodyXL--R4tXV,.ConfusionMatrixContainer-module__dsBodyXL--R4tXV *{font-size:18px;line-height:27px}.ConfusionMatrixContainer-module__dsBodyLarge--UuBi6,.ConfusionMatrixContainer-module__dsBodyLarge--UuBi6 *{font-size:16px;line-height:24px}.ConfusionMatrixContainer-module__dsBody--rWO_b,.ConfusionMatrixContainer-module__dsBody--rWO_b *{font-size:14px;line-height:20px}.ConfusionMatrixContainer-module__dsBodySmall--WXSGb,.ConfusionMatrixContainer-module__dsBodySmall--WXSGb *{font-size:12px;line-height:18px}.ConfusionMatrixContainer-module__dsBodyXS--zrYsp,.ConfusionMatrixContainer-module__dsBodyXS--zrYsp *{font-size:10px;line-height:15px}.ConfusionMatrixContainer-module__dsActionLarge--vYLbi,.ConfusionMatrixContainer-module__dsActionLarge--vYLbi *{font-size:16px;line-height:18px}.ConfusionMatrixContainer-module__dsAction--aGDaF,.ConfusionMatrixContainer-module__dsAction--aGDaF *{font-size:14px;line-height:16px}.ConfusionMatrixContainer-module__dsActionSmall--Ya8EJ,.ConfusionMatrixContainer-module__dsActionSmall--Ya8EJ *{font-size:12px;line-height:14px}.ConfusionMatrixContainer-module__dsColumnHeadLine--Wzk_B,.ConfusionMatrixContainer-module__dsColumnHeadLine--Wzk_B *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.ConfusionMatrixContainer-module__dsLightXL--w7leH,.ConfusionMatrixContainer-module__dsLightXL--w7leH *{font-size:120px;line-height:160px;font-weight:300}.ConfusionMatrixContainer-module__dsLightLarge--kHrb_,.ConfusionMatrixContainer-module__dsLightLarge--kHrb_ *{font-size:48px;line-height:64px;font-weight:300}.ConfusionMatrixContainer-module__dsLight--gOWwt,.ConfusionMatrixContainer-module__dsLight--gOWwt *{font-size:32px;line-height:64px;font-weight:300}.ConfusionMatrixContainer-module__dsLightSmall--lNNaS,.ConfusionMatrixContainer-module__dsLightSmall--lNNaS *{font-size:24px;line-height:36px;font-weight:300}.ConfusionMatrixContainer-module__dsLightXS--r9_it,.ConfusionMatrixContainer-module__dsLightXS--r9_it *{font-size:18px;line-height:27px;font-weight:300}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH{flex-shrink:0;border:1px solid var(--gray-1);background:var(--white);border-radius:5px;min-width:400px;cursor:default;--thumb-width: 77px}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH .ConfusionMatrixContainer-module__header--pa9Xm{display:flex;flex-direction:row;align-items:center;justify-content:space-between;height:30px;padding:0 8px;position:sticky;left:0;max-width:var(--matrix-container-width)}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH .ConfusionMatrixContainer-module__header--pa9Xm .ConfusionMatrixContainer-module__titleContainer--noMra{flex:3 1 calc((100% - var(--thumb-width))/2);min-width:0;display:flex;flex-direction:row;align-items:center;gap:4px;flex-wrap:nowrap}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH .ConfusionMatrixContainer-module__header--pa9Xm .ConfusionMatrixContainer-module__titleContainer--noMra .ConfusionMatrixContainer-module__color--j4NrH{flex-shrink:0;--size: 12px;width:var(--size);height:var(--size);border-radius:var(--size)}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH .ConfusionMatrixContainer-module__header--pa9Xm .ConfusionMatrixContainer-module__titleContainer--noMra .ConfusionMatrixContainer-module__title--kNMC_{font-size:12px;line-height:18px;color:var(--black);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH .ConfusionMatrixContainer-module__header--pa9Xm .ConfusionMatrixContainer-module__dragHandle--Zo5Bx{display:flex;align-items:center;justify-content:center;flex:0 0 var(--thumb-width);height:100%;color:#8c95a8;opacity:0}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH .ConfusionMatrixContainer-module__header--pa9Xm .ConfusionMatrixContainer-module__sliderContainer--wiFuH{flex:3 1 calc((100% - var(--thumb-width))/2);display:flex;justify-content:flex-end}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH .ConfusionMatrixContainer-module__header--pa9Xm .ConfusionMatrixContainer-module__sliderContainer--wiFuH .ConfusionMatrixContainer-module__sliderBox--Uf8yN{min-width:150px;max-width:300px;width:100%;display:flex;justify-content:stretch;--slider-title-width: 30px;--slider-title-margin: 4px}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH .ConfusionMatrixContainer-module__header--pa9Xm .ConfusionMatrixContainer-module__sliderContainer--wiFuH .ConfusionMatrixContainer-module__sliderBox--Uf8yN .ConfusionMatrixContainer-module__sliderTitle--IMj3W{flex-basis:var(--slider-title-width);margin-right:var(--slider-title-margin);font-size:12px;line-height:18px;color:var(--gray-7)}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH .ConfusionMatrixContainer-module__header--pa9Xm .ConfusionMatrixContainer-module__sliderContainer--wiFuH .ConfusionMatrixContainer-module__sliderBox--Uf8yN .ConfusionMatrixContainer-module__sliderWrapper--hwWP6{flex-basis:calc(100% - var(--slider-title-width) - var(--slider-title-margin))}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH .ConfusionMatrixContainer-module__header--pa9Xm .ConfusionMatrixContainer-module__sliderContainer--wiFuH .ConfusionMatrixContainer-module__sliderBox--Uf8yN .ConfusionMatrixContainer-module__sliderWrapper--hwWP6 .value-label{font-size:12px;line-height:18px;color:var(--gray-7);width:auto}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH:hover .ConfusionMatrixContainer-module__dragHandle--Zo5Bx{cursor:all-scroll;opacity:1}.ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH .ConfusionMatrixContainer-module__body--Q0ij5{min-height:200px;padding:8px;display:flex;align-items:center;justify-content:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `ConfusionMatrixContainer-module__dsAccented--vq4_j`,
	"dsDefaultWeight": `ConfusionMatrixContainer-module__dsDefaultWeight--snGUb`,
	"dsUnderline": `ConfusionMatrixContainer-module__dsUnderline--ISw2P`,
	"dsAccented2": `ConfusionMatrixContainer-module__dsAccented2--SAnCD`,
	"dsBodyXL": `ConfusionMatrixContainer-module__dsBodyXL--R4tXV`,
	"dsBodyLarge": `ConfusionMatrixContainer-module__dsBodyLarge--UuBi6`,
	"dsBody": `ConfusionMatrixContainer-module__dsBody--rWO_b`,
	"dsBodySmall": `ConfusionMatrixContainer-module__dsBodySmall--WXSGb`,
	"dsBodyXS": `ConfusionMatrixContainer-module__dsBodyXS--zrYsp`,
	"dsActionLarge": `ConfusionMatrixContainer-module__dsActionLarge--vYLbi`,
	"dsAction": `ConfusionMatrixContainer-module__dsAction--aGDaF`,
	"dsActionSmall": `ConfusionMatrixContainer-module__dsActionSmall--Ya8EJ`,
	"dsColumnHeadLine": `ConfusionMatrixContainer-module__dsColumnHeadLine--Wzk_B`,
	"dsLightXL": `ConfusionMatrixContainer-module__dsLightXL--w7leH`,
	"dsLightLarge": `ConfusionMatrixContainer-module__dsLightLarge--kHrb_`,
	"dsLight": `ConfusionMatrixContainer-module__dsLight--gOWwt`,
	"dsLightSmall": `ConfusionMatrixContainer-module__dsLightSmall--lNNaS`,
	"dsLightXS": `ConfusionMatrixContainer-module__dsLightXS--r9_it`,
	"confusionMatrixContainer": `ConfusionMatrixContainer-module__confusionMatrixContainer--VC0KH`,
	"header": `ConfusionMatrixContainer-module__header--pa9Xm`,
	"titleContainer": `ConfusionMatrixContainer-module__titleContainer--noMra`,
	"color": `ConfusionMatrixContainer-module__color--j4NrH`,
	"title": `ConfusionMatrixContainer-module__title--kNMC_`,
	"dragHandle": `ConfusionMatrixContainer-module__dragHandle--Zo5Bx`,
	"sliderContainer": `ConfusionMatrixContainer-module__sliderContainer--wiFuH`,
	"sliderBox": `ConfusionMatrixContainer-module__sliderBox--Uf8yN`,
	"sliderTitle": `ConfusionMatrixContainer-module__sliderTitle--IMj3W`,
	"sliderWrapper": `ConfusionMatrixContainer-module__sliderWrapper--hwWP6`,
	"body": `ConfusionMatrixContainer-module__body--Q0ij5`
};
module.exports = ___CSS_LOADER_EXPORT___;
